import Button from "@/common/elements/Button";
import {
  InmateDetailsTableContainer,
  TableHeader,
} from "@/components/InmateDetails/styles";
import { useEffect, useRef, useState } from "react";
import ActivityLogModal from "./ActivityLogModal";
import AssignmentsModal from "./AssignmentsModal";
import DataTable from "@/common/elements/DataTable";
import { StyledFlex } from "@/common/styles";
import { useDispatch, useSelector } from "react-redux";
import { isNonEmptyVariable } from "@/util/common_function";
import { setBookings, setDeleteAPis } from "@/slices/bookingsSlice";
import _ from "lodash";
import { v4 as uuidV4 } from "uuid";
import dayjs from "dayjs";
import API_ENDPOINTS from "@/util/api";
import Popconfirm from "@/common/elements/Popconfirm";

const AssignmentsTableHeaders = [
  { key: "id", text: "#" },
  { key: ["servicesHr", 0, "assignment"], text: "Assignment" },
  { key: "startDate", text: "Start Date" },
  { key: "endDate", text: "End Date" },
  { key: ["servicesHr", 0, "assignmentType"], text: "Assignment Type" },
];
const ActivityLogTableHeaders = [
  { key: "id", text: "#" },
  { key: "activityType", text: "Activity Type" },
  { key: "startDate", text: "Start Date" },
  { key: "endDate", text: "End Date" },
  { key: "hoursAffected", text: "Hours Affected" },
];

const AssignmentLog = () => {
  const dispatch = useDispatch();
  const { bookings, bookingsFieldsEnabled } = useSelector((s) => s?.bookings);
  const [isAssignmentsModalShown, setIsAssignmentsModalShown] = useState(false);
  const [isActivityLogModalShown, setIsActivityLogModalShown] = useState(false);
  const [assignmentList, setAssignmentList] = useState([]);
  const [activityLogList, setActivityLogList] = useState([]);
  const [selectAssignment, setSelectAssignment] = useState(null);
  const [selectActivity, setSelectActivity] = useState(null);
  const dataTableAssignmentRef = useRef();
  const dataTableActivityRef = useRef();

  useEffect(() => {
    if (isNonEmptyVariable(bookings)) {
      if (bookings?.staffServiceHr?.length) {
        const med = bookings?.staffServiceHr?.map((m, index) => {
          return {
            ...m,
            id: index + 1,
            uuid: uuidV4(),
          };
        });
        setAssignmentList(() => med);
      } else {
        setAssignmentList(() => []);
      }

      if (bookings?.activityLogHR?.length) {
        const al = bookings?.activityLogHR?.map((m, index) => {
          return {
            ...m,
            id: index + 1,
            uuid: uuidV4(),
          };
        });
        setActivityLogList(() => al);
      } else {
        setActivityLogList(() => []);
      }
    }
  }, [bookings]);

  const onRowClick = (value, index, name) => {
    if (isNonEmptyVariable(value)) {
      if (name === "assignment") {
        const data = {
          ...value,
          startDate: isNonEmptyVariable(value?.startDate)
            ? dayjs(value?.startDate)
            : null,
          endDate: isNonEmptyVariable(value?.endDate)
            ? dayjs(value?.endDate)
            : null,
        };
        setSelectAssignment(() => data);
      } else {
        const data = {
          ...value,
          startDate: isNonEmptyVariable(value?.startDate)
            ? dayjs(value?.startDate)
            : null,
          endDate: isNonEmptyVariable(value?.endDate)
            ? dayjs(value?.endDate)
            : null,
        };
        setSelectActivity(() => data);
      }
      if(index !== undefined && index !== null) {
        if (name === "assignment") {
          onEditClick("assignment");
        } else {
          onEditClick("activity");
        }
      }
    }
  };

  const onAddClick = (name) => {
    if (name === "assignment") {
      setSelectAssignment(() => null);
      setIsAssignmentsModalShown(true);
    } else {
      setSelectActivity(() => null);
      setIsActivityLogModalShown(true);
    }
  };

  const onEditClick = (name) => {
    if (name === "assignment") {
      setIsAssignmentsModalShown(true);
    } else {
      setIsActivityLogModalShown(true);
    }
  };

  const handleCancel = (name) => {
    if (name === "assignment") {
      setSelectAssignment(() => null);
      setIsAssignmentsModalShown(false);
      dataTableAssignmentRef?.current?.resetAll();
    } else {
      setSelectActivity(() => null);
      setIsActivityLogModalShown(false);
      dataTableActivityRef?.current?.resetAll();
    }
  };

  const handleSubmit = (values, name) => {
    if (name === "assignment") {
      console.log(values);
      let assignmentListData = _.cloneDeep(assignmentList);
      if (isNonEmptyVariable(selectAssignment)) {
        assignmentListData = assignmentListData?.map((m) => {
          if (m?.uuid === selectAssignment?.uuid) {
            return {
              ...m,
              ...values,
              servicesHr: [
                {
                  ...m?.servicesHr?.[0],
                  ...values?.servicesHr?.[0],
                },
              ],
            };
          }

          return m;
        });
      } else {
        assignmentListData.push(values);
      }

      setAssignmentList(() => assignmentListData);
      dispatch(
        setBookings({
          staffServiceHr: assignmentListData,
        })
      );

      handleCancel("assignment");
    } else {
      let activityLogListData = _.cloneDeep(activityLogList);
      if (isNonEmptyVariable(selectActivity)) {
        activityLogListData = activityLogListData?.map((m) => {
          if (m?.uuid === selectActivity?.uuid) {
            return {
              ...m,
              ...values,
            };
          }

          return m;
        });
      } else {
        activityLogListData.push(values);
      }

      setActivityLogList(() => activityLogListData);
      dispatch(
        setBookings({
          activityLogHR: activityLogListData,
        })
      );
      handleCancel("activity");
    }
  };

  const handleDelete = (name) => {
    if (name === "assignment") {
      let assignmentListData = _.cloneDeep(assignmentList);
      if (isNonEmptyVariable(selectAssignment)) {
        assignmentListData = assignmentListData?.filter(
          (m) => m?.uuid !== selectAssignment?.uuid
        );

        if (isNonEmptyVariable(selectAssignment?.staffServiceHrId)) {
          const url =
            API_ENDPOINTS.staff.assignment.delete +
            selectAssignment?.staffServiceHrId;
          dispatch(setDeleteAPis(url));
        }
      }

      setAssignmentList(() => assignmentListData);
      dispatch(
        setBookings({
          staffServiceHr: assignmentListData,
        })
      );

      handleCancel("assignment");
    } else {
      let activityLogListData = _.cloneDeep(activityLogList);
      if (isNonEmptyVariable(selectActivity)) {
        activityLogListData = activityLogListData?.filter(
          (m) => m?.uuid !== selectActivity?.uuid
        );

        if (isNonEmptyVariable(selectActivity?.activityLogHrId)) {
          const url =
            API_ENDPOINTS.staff.activityLog.delete +
            selectActivity?.activityLogHrId;
          dispatch(setDeleteAPis(url));
        }
      }

      setActivityLogList(() => activityLogListData);
      dispatch(
        setBookings({
          activityLogHR: activityLogListData,
        })
      );

      handleCancel("activity");
    }
  };

  return (
    <>
      <InmateDetailsTableContainer>
        <TableHeader>
          <h6>Assignments</h6>
          <StyledFlex gap="10px">
            <Button
              color="primary"
              type="primary"
              className="add-btn"
              onClick={() => onAddClick("assignment")}
              disabled={!bookingsFieldsEnabled}
            >
              Add
            </Button>
            <Button
              onClick={() => onEditClick("assignment")}
              disabled={selectAssignment === null}
            >
              Details
            </Button>
            <Popconfirm
              title="Delete the assignment"
              description="Are you sure to delete this assignment record?"
              onConfirm={() => handleDelete("assignment")}
              onCancel={() => { }}
              okText="Yes"
              cancelText="No"
            >
              <Button
                color="primary"
                type="primary"
                disabled={selectAssignment === null || !bookingsFieldsEnabled}
              >
                Delete
              </Button>
            </Popconfirm>
            <Button
              onClick={() => handleCancel("assignment")}
              disabled={selectAssignment === null}
            >
              Cancel
            </Button>
          </StyledFlex>
        </TableHeader>
        <DataTable
          ref={dataTableAssignmentRef}
          rowUniqueId="uuid"
          headers={AssignmentsTableHeaders}
          data={assignmentList}
          style={{ padding: "unset" }}
          onRowClick={(record, index) => onRowClick(record, index, "assignment")}
          selected={selectAssignment === null}
          allowTableSorting={true}
        />
      </InmateDetailsTableContainer>

      <InmateDetailsTableContainer>
        <TableHeader>
          <h6>Activity Log</h6>
          <StyledFlex gap="10px">
            <Button
              color="primary"
              type="primary"
              className="add-btn"
              onClick={() => onAddClick("activity")}
              disabled={!bookingsFieldsEnabled}
            >
              Add
            </Button>
            <Button
              onClick={() => onEditClick("activity")}
              disabled={selectActivity === null}
            >
              Details
            </Button>

            <Popconfirm
              title="Delete the activity log"
              description="Are you sure to delete this activity log?"
              onConfirm={() => handleDelete("activity")}
              onCancel={() => { }}
              okText="Yes"
              cancelText="No"
            >
              <Button
                color="primary"
                type="primary"
                disabled={selectActivity === null || !bookingsFieldsEnabled}
              >
                Delete
              </Button>
            </Popconfirm>
            <Button
              onClick={() => handleCancel("activity")}
              disabled={selectActivity === null}
            >
              Cancel
            </Button>
          </StyledFlex>
        </TableHeader>
        <DataTable
          ref={dataTableActivityRef}
          rowUniqueId="uuid"
          headers={ActivityLogTableHeaders}
          data={activityLogList}
          // style={{ padding: "unset" }}
          onRowClick={(record, index) => onRowClick(record, index, "activity")}
          selected={selectActivity !== null}
          allowTableSorting={true}
        />
      </InmateDetailsTableContainer>
      <AssignmentsModal
        show={isAssignmentsModalShown}
        handleCancel={() => handleCancel("assignment")}
        formSubmit={(e) => handleSubmit(e, "assignment")}
        selectAssignment={selectAssignment}
        bookingsFieldsEnabled={bookingsFieldsEnabled}
      />
      <ActivityLogModal
        show={isActivityLogModalShown}
        handleCancel={() => handleCancel("activity")}
        formSubmit={(e) => handleSubmit(e, "activity")}
        selectActivity={selectActivity}
        bookingsFieldsEnabled={bookingsFieldsEnabled}
      />
    </>
  );
};

export default AssignmentLog;
